/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { WearablesStrictHttpResponse } from '../../wearables-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IntergatedSystemWebhookEvent } from '../../models/intergated-system-webhook-event';
import { WebhookTestRequest } from '../../models/webhook-test-request';

export interface ExternalWebhookTestProfileIdPost$Params {

/**
 * The member profile identifier.
 */
  profileId: string;
  
    /**
     * The webhook test request specifying either a concrete event type or that goal events should be generated.
     */
    body?: WebhookTestRequest
}

export function externalWebhookTestProfileIdPost(http: HttpClient, rootUrl: string, params: ExternalWebhookTestProfileIdPost$Params, context?: HttpContext): Observable<WearablesStrictHttpResponse<IntergatedSystemWebhookEvent>> {
  const rb = new RequestBuilder(rootUrl, externalWebhookTestProfileIdPost.PATH, 'post');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as WearablesStrictHttpResponse<IntergatedSystemWebhookEvent>;
    })
  );
}

externalWebhookTestProfileIdPost.PATH = '/External/WebhookTest/{profileId}';
